export default __webpack_public_path__ + "static/media/detail_big_15_6.c2e8cfe4.jpg";